// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmEquipmentStatus {
constructor({
        id = null,
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new EmEquipmentStatus();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.em.archive.emEquipmentStatus.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.archive.emEquipmentStatus.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.archive.emEquipmentStatus.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.archive.emEquipmentStatus.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.archive.emEquipmentStatus.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmEquipmentStatus, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
